import React,{useState} from "react";

import HeroSection from "./components/HeroSection";
import MiddleSection from "./components/MiddleSection";
import BottomSection from "./components/BottomSection";
import FeatureSection from "./components/FeatureSection";
import IntelliTutorForEveryone from "./components/IntelliTutorForEveryone"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ChatPage from "./components/ChatPage";
import TeacherPage from './components/TeacherPage'
import CourseDetail from './components/CourseDetail'

import "./App.css";
import "./theme.css";

function Home() {
  return (
    <>
      <HeroSection />
      <FeatureSection />
      <IntelliTutorForEveryone />
      <BottomSection />
    </>
  );
}

function App() {
  // const [userToken, setUserToken] = useState(null);
  // const handleLogin = (credentialResponse) => {
  //   console.log(credentialResponse)
  //   // if (!credentialResponse?.credential) {
  //   //   console.error("No credential received");
  //   //   return;
  //   // }
  //   const decoded = jwtDecode(credentialResponse);
  //   console.log(decoded)
  //   setUserToken(decoded);
  // };
  // if (!userToken) {
  //   return (
  //     <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
  //       <LoginButton onSuccess={handleLogin} />
  //     </div>
  //   );
  // }
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/teacher" element={<TeacherPage />} />
        <Route path="/teacher/course/:courseId" element={<CourseDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
